<template>

    <jet-confirmation-modal v-if="content.data"
                            :show="content.data.tipoTransferencia.indexOf(['ted', 'p2p']) && content.visible"
                            @close="!content.visible">
        <template #title>
            <div class="mt-1">Comprovante de transferência</div>
        </template>

        <template #content>
            <ticket :account="account" :content="content"/>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="$emit('closeModal')">
                Fechar
            </jet-secondary-button>

            <jet-ok-button @click.native="print">
                <i class="fas fa-print"></i>&nbsp;Imprimir
            </jet-ok-button>
        </template>
    </jet-confirmation-modal>

</template>

<script>
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetFormSection from "../../Jetstream/FormSection";
import JetOkButton from "../../Jetstream/OkButton";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetSectionBorder from "../../Jetstream/SectionBorder";
import ApplicationMark from "../../Jetstream/ApplicationMark";
import Ticket from "./Ticket";

export default {
    props: {
        content: {
            type: Object,
            default: {}
        },
        account: {
            type: Object,
            default: null
        }
    },
    methods: {
        parseType: function (type) {
            switch (type) {
                case 'ted':
                    return 'ENVIO TED';
                case 'p2p':
                    return 'ENTRE CONTAS DÉBITO';
                default:
                    return type;
            }
        },
        print() {
            const prtHtml = document.getElementById('transfer-receipt').innerHTML;
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(`<!DOCTYPE html><html><head>${stylesHtml}</head><body><div style="width: 300px">${prtHtml}</div></body></html>`);
            WinPrint.document.close();
            WinPrint.focus();
            setTimeout(() => {
                WinPrint.print()
                WinPrint.close();
            }, 1000);
        }
    },
    data() {
        return {
            viewTransfer: true,
            viewBoleto: false
        }
    },
    components: {
        ApplicationMark,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton,
        JetSectionBorder,
        JetFormSection,
        JetSecondaryButton,
        Ticket
    },
}
</script>
